import axios from 'axios'
import { ElMessage } from 'element-plus'
// import { useMainStore } from '@/stores/main.ts'
// const { addMessages } = useMainStore()
const instance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASEURL_CENTER,
  timeout: 10000,
  // method: 'GET',
  headers: { 'Content-Type': 'application/json' },
})

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  },
)

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    if (response.data && response.data.code !== 0) {
      console.error(response)
      // ElMessage.error('请求错误 code: ' + response.data.code)
      // addMessages({
      //   type: 'info',
      //   msg: '请求错误 错误code: ' + response.data.code,
      // })
    }
    return response.data
  },
  function (error) {
    // ElMessage.error('请求出错了 !', error)
    console.error('请求出错了 !', error)
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error)
  },
)
export default instance
